import { IcoScale } from "./icons";

export function LegalBtn({ onOpen }: { onOpen: () => void }) {
  return (
    <button type="button" className="sg-btn ghost" onClick={onOpen} aria-label="Cadre d’Aurélia Signature">
      <IcoScale />
      Cadre
    </button>
  );
}
